import { render, staticRenderFns } from "./quick-operation.vue?vue&type=template&id=71f2f6b0&"
import script from "./quick-operation.vue?vue&type=script&lang=js&"
export * from "./quick-operation.vue?vue&type=script&lang=js&"
import style0 from "./quick-operation.vue?vue&type=style&index=0&id=71f2f6b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports